import React, { useState, useEffect } from 'react';
import '../styles/ServerStatusWidget.css';

const ServerStatusWidget = () => {
  const [services, setServices] = useState([
    { id: 'api', name: 'API', status: 'loading' },
    { id: 'db', name: 'Database', status: 'loading' },
    { id: 'auth', name: 'Auth', status: 'loading' },
    { id: 'storage', name: 'Storage', status: 'loading' }
  ]);
  const [lastUpdated, setLastUpdated] = useState(null);

  useEffect(() => {
    const checkServices = async () => {
      try {
        // In production, replace with actual API calls to your health endpoints
        const mockCheck = async () => {
          // Simulate API calls
          await new Promise(resolve => setTimeout(resolve, 300));
          
          const results = services.map(service => ({
            ...service,
            // 95% chance of success for demo purposes
            status: Math.random() > 0.05 ? 'operational' : 'issue'
          }));
          
          setServices(results);
          setLastUpdated(new Date());
        };
        
        mockCheck();
      } catch (error) {
        console.error("Failed to check service status:", error);
      }
    };

    checkServices();
    const interval = setInterval(checkServices, 60000); // Check every minute
    
    return () => clearInterval(interval);
  }, []);

  const getSystemStatus = () => {
    if (services.every(s => s.status === 'operational')) return 'All Systems Operational';
    if (services.some(s => s.status === 'down')) return 'System Outage Detected';
    if (services.some(s => s.status === 'issue')) return 'Performance Issues Detected';
    return 'Checking System Status...';
  };

  return (
    <div className="server-status-led-panel">
      <div className="led-status-text">{getSystemStatus()}</div>
      <div className="led-indicators">
        {services.map(service => (
          <div key={service.id} className="led-indicator-container" title={`${service.name}: ${service.status === 'operational' ? 'Operational' : service.status === 'issue' ? 'Performance Issue' : 'Loading'}`}>
            <div className={`led-indicator ${service.status}`}></div>
            <div className="led-label">{service.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServerStatusWidget; 